module.exports = __webpack_public_path__ + "static/media/Sekcja3.3d442914.jpg";